export const carouselItems = [
  {
    id: 1,
    title: "2026 暑期档大剧连播",
    desc: "古装传奇、都市情感、悬疑推理三大赛道同步发力，每日三集连播不间断，这个夏天追剧不停歇。",
    tag: "热门专题",
    img: "https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20poster%20style%20banner%20showing%20ancient%20Chinese%20palace%20with%20dramatic%20warm%20golden%20lighting%2C%20epic%20atmosphere%2C%20film%20grain%20texture%2C%20professional%20cinematography%20style%2C%20rich%20contrast%20with%20deep%20shadows%20and%20warm%20highlights%2C%20horizontal%20composition%2C%20theatrical%20mood&width=800&height=500&seq=carousel-1&orientation=landscape"
  },
  {
    id: 2,
    title: "高分电影完整版专区",
    desc: "豆瓣8.0+精选片库，从经典老片到院线新作，无删减完整版一站收录，画质最高支持4K超清。",
    tag: "电影专题",
    img: "https://readdy.ai/api/search-image?query=A%20movie%20theater%20interior%20with%20red%20velvet%20seats%20and%20a%20glowing%20large%20screen%20showing%20cinematic%20light%2C%20warm%20ambient%20lighting%2C%20luxurious%20atmosphere%2C%20film%20projector%20beam%20cutting%20through%20darkness%2C%20professional%20photography%2C%20rich%20textures&width=800&height=500&seq=carousel-2&orientation=landscape"
  },
  {
    id: 3,
    title: "综艺热力榜 TOP20",
    desc: "音乐竞演、户外真人秀、语言喜剧三大品类全覆盖，每周五晚同步更新，弹幕互动超千万条。",
    tag: "综艺聚焦",
    img: "https://readdy.ai/api/search-image?query=A%20vibrant%20television%20variety%20show%20stage%20with%20colorful%20dynamic%20lighting%2C%20neon%20accents%2C%20concert-like%20atmosphere%2C%20excited%20crowd%20silhouettes%2C%20professional%20broadcast%20studio%20setting%2C%20warm%20and%20energetic%20mood%2C%20wide%20horizontal%20shot&width=800&height=500&seq=carousel-3&orientation=landscape"
  },
  {
    id: 4,
    title: "不缓冲技术全解析",
    desc: "自研P2P-CDN混合加速架构，覆盖全国300+节点，高峰时段播放流畅度99.7%，彻底告别卡顿。",
    tag: "技术专题",
    img: "https://readdy.ai/api/search-image?query=A%20futuristic%20data%20center%20with%20glowing%20server%20racks%20and%20network%20visualization%2C%20streaming%20technology%20concept%2C%20warm%20amber%20and%20coral%20accent%20lights%2C%20professional%20tech%20photography%2C%20clean%20modern%20aesthetic%2C%20horizontal%20composition&width=800&height=500&seq=carousel-4&orientation=landscape"
  },
  {
    id: 5,
    title: "新用户观影指南",
    desc: "从注册到追剧只需30秒，智能推荐系统自动匹配口味偏好，片单收藏、续播记忆、多端同步一应俱全。",
    tag: "新手引导",
    img: "https://readdy.ai/api/search-image?query=A%20cozy%20living%20room%20with%20a%20large%20TV%20screen%20displaying%20a%20streaming%20interface%2C%20warm%20evening%20atmosphere%2C%20comfortable%20sofa%2C%20soft%20ambient%20lighting%2C%20modern%20home%20entertainment%20setup%2C%20cinematic%20mood%2C%20horizontal%20composition&width=800&height=500&seq=carousel-5&orientation=landscape"
  }
];

export const cardItems = [
  {
    id: 1,
    title: "《长安十二时辰》高清完整版",
    desc: "雷佳音、易烊千玺主演古装悬疑巨制，48集全收录",
    tag: "电视剧",
    rating: "9.2",
    img: "https://readdy.ai/api/search-image?query=A%20dramatic%20ancient%20Chinese%20city%20scene%20at%20night%20with%20lanterns%20and%20traditional%20architecture%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%20with%20warm%20golden%20tones%2C%20film%20poster%20aesthetic%2C%20professional%20photography&width=600&height=380&seq=card-1&orientation=landscape"
  },
  {
    id: 2,
    title: "《流浪地球3》导演剪辑版",
    desc: "吴京、刘德华领衔，中国科幻巅峰之作全新版本",
    tag: "电影",
    rating: "8.8",
    img: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20spacescape%20with%20a%20massive%20planet%20and%20spaceship%2C%20cinematic%20lighting%2C%20deep%20space%20atmosphere%2C%20dramatic%20orange%20and%20teal%20color%20grading%2C%20professional%20film%20still%20quality%2C%20horizontal%20composition&width=600&height=380&seq=card-2&orientation=landscape"
  },
  {
    id: 3,
    title: "《声生不息·大湾区季》全集",
    desc: "殿堂级音乐人齐聚，粤语金曲新编演绎",
    tag: "综艺",
    rating: "9.0",
    img: "https://readdy.ai/api/search-image?query=A%20grand%20music%20stage%20with%20dramatic%20spotlights%20and%20musical%20instruments%2C%20concert%20atmosphere%2C%20warm%20golden%20and%20coral%20lighting%2C%20professional%20broadcast%20photography%2C%20horizontal%20wide%20shot&width=600&height=380&seq=card-3&orientation=landscape"
  },
  {
    id: 4,
    title: "《庆余年》第二季全集",
    desc: "张若昀、陈道明主演，权谋与江湖的完美交织",
    tag: "电视剧",
    rating: "9.5",
    img: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20courtyard%20with%20dramatic%20shadows%20and%20warm%20sunlight%2C%20historical%20drama%20aesthetic%2C%20elegant%20traditional%20costumes%2C%20cinematic%20composition%2C%20rich%20textures%2C%20horizontal%20shot&width=600&height=380&seq=card-4&orientation=landscape"
  },
  {
    id: 5,
    title: "《繁花》沪语版完整收录",
    desc: "王家卫首部电视剧，胡歌马伊琍演绎上海往事",
    tag: "电视剧",
    rating: "9.3",
    img: "https://readdy.ai/api/search-image?query=1990s%20Shanghai%20street%20scene%20with%20neon%20signs%20and%20vintage%20cars%2C%20nostalgic%20cinematic%20lighting%2C%20warm%20golden%20hour%20glow%2C%20film%20noir%20aesthetic%2C%20professional%20photography%2C%20horizontal%20composition&width=600&height=380&seq=card-5&orientation=landscape"
  },
  {
    id: 6,
    title: "《哪吒之魔童闹海》加长版",
    desc: "国产动画票房冠军，新增15分钟独家幕后花絮",
    tag: "电影",
    rating: "9.1",
    img: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20scene%20with%20fire%20and%20lightning%20effects%2C%20animated%20fantasy%20style%2C%20dramatic%20warm%20orange%20and%20red%20lighting%2C%20cinematic%20atmosphere%2C%20horizontal%20composition&width=600&height=380&seq=card-6&orientation=landscape"
  },
  {
    id: 7,
    title: "《长相思》第二季独家上线",
    desc: "杨紫、张晚意主演，上古神话虐恋引爆话题",
    tag: "电视剧",
    rating: "8.9",
    img: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20landscape%20with%20blossoming%20trees%20and%20misty%20mountains%2C%20romantic%20atmosphere%2C%20soft%20warm%20lighting%2C%20ethereal%20cinematic%20style%2C%20horizontal%20composition%2C%20dreamy%20mood&width=600&height=380&seq=card-7&orientation=landscape"
  }
];

export const commentItems = [
  {
    id: 1,
    user: "追剧达人小王",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Chinese%20man%20with%20warm%20friendly%20expression%2C%20clean%20studio%20portrait%2C%20soft%20lighting%2C%20simple%20neutral%20background&width=80&height=80&seq=avatar-1&orientation=squarish",
    content: "用了色影视三个月了，最大的感受就是真的不卡！以前用别的平台追剧，一到晚上高峰期就缓冲到崩溃，换到这边之后几乎没遇到过卡顿。片库也全，《庆余年2》更新当天就能看，太爽了。",
    rating: 5,
    date: "2026-07-28"
  },
  {
    id: 2,
    user: "电影发烧友小陈",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Chinese%20woman%20with%20glasses%20and%20warm%20smile%2C%20clean%20studio%20portrait%2C%20soft%20lighting%2C%20simple%20neutral%20background&width=80&height=80&seq=avatar-2&orientation=squarish",
    content: "作为一个重度电影爱好者，色影视的电影完整版专区简直是宝藏！很多冷门高分片都能找到，而且都是完整版无删减。画质也够清晰，投屏到电视上看体验特别好。推荐给所有爱看电影的朋友！",
    rating: 5,
    date: "2026-07-25"
  },
  {
    id: 3,
    user: "综艺追不停",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Chinese%20person%20with%20casual%20style%20and%20warm%20expression%2C%20clean%20studio%20portrait%2C%20soft%20lighting%2C%20simple%20neutral%20background&width=80&height=80&seq=avatar-3&orientation=squarish",
    content: "每周五晚固定蹲守色影视看综艺更新！弹幕社区氛围也很好，大家一起吐槽一起笑。手机端和电脑端无缝切换，通勤路上用手机看，回家用电脑大屏接着看，进度自动同步，太方便了。",
    rating: 5,
    date: "2026-07-30"
  }
];

export const rankingItems = [
  { id: 1, rank: 1, title: "《庆余年》第二季", tag: "电视剧", heat: "9.8", trend: "up", desc: "张若昀陈道明主演，权谋江湖巨制" },
  { id: 2, rank: 2, title: "《声生不息·大湾区季》", tag: "综艺", heat: "9.6", trend: "up", desc: "殿堂级音乐人粤语金曲新编" },
  { id: 3, rank: 3, title: "《流浪地球3》导剪版", tag: "电影", heat: "9.5", trend: "up", desc: "中国科幻巅峰全新版本" },
  { id: 4, rank: 4, title: "《繁花》沪语版", tag: "电视剧", heat: "9.3", trend: "stable", desc: "王家卫首部电视剧，胡歌主演" },
  { id: 5, rank: 5, title: "《哪吒之魔童闹海》", tag: "电影", heat: "9.1", trend: "up", desc: "国产动画票房冠军加长版" }
];

export const indexItems = [
  { id: 1, title: "古装剧集", count: 286, icon: "ri-building-2-line", desc: "仙侠、宫斗、权谋、武侠全覆盖" },
  { id: 2, title: "悬疑推理", count: 173, icon: "ri-search-eye-line", desc: "烧脑剧情、反转不断、一次追完" },
  { id: 3, title: "都市情感", count: 215, icon: "ri-heart-line", desc: "爱情、家庭、职场多元题材" },
  { id: 4, title: "科幻动作", count: 142, icon: "ri-rocket-line", desc: "国产科幻崛起，特效震撼体验" },
  { id: 5, title: "喜剧综艺", count: 98, icon: "ri-emotion-laugh-line", desc: "语言类、真人秀、音乐竞演" },
  { id: 6, title: "动漫专区", count: 267, icon: "ri-movie-line", desc: "国产动画、日漫、美漫全收录" },
  { id: 7, title: "纪录片库", count: 154, icon: "ri-earth-line", desc: "自然、历史、人文深度纪实" }
];

export const faqItems = [
  {
    id: 1,
    q: "色影视需要付费吗？有广告吗？",
    a: "色影视目前所有内容均可免费在线观看，平台通过贴片广告维持运营。我们承诺片前广告不超过15秒，观影过程中不插播广告，确保追剧体验不被打断。未来可能会推出会员去广告服务，但免费观看的基础服务将长期保留。"
  },
  {
    id: 2,
    q: "播放卡顿怎么办？如何提升画质？",
    a: "色影视采用P2P-CDN混合加速技术，在全国部署了300+加速节点。如果遇到卡顿，建议：1）切换到较低清晰度（播放器右下角可调）；2）检查本地网络状态；3）避开晚间8-11点全网高峰。正常情况下1080P流畅播放所需带宽仅需5Mbps。"
  },
  {
    id: 3,
    q: "支持哪些设备观看？可以投屏吗？",
    a: "色影视全面支持PC浏览器、手机浏览器（iOS/Android）、平板设备访问。所有内容均支持DLNA和AirPlay投屏协议，可在智能电视、投影仪等大屏设备上观看。手机端还支持画中画模式，边聊微信边追剧两不误。"
  },
  {
    id: 4,
    q: "影片更新速度如何？新剧多久上线？",
    a: "热门电视剧通常在电视台播出后2-4小时内完成更新上线；电影资源在数字版发行后24小时内提供高清版本；综艺节目每周五、六、日晚间同步更新。我们拥有专业的内容采编团队，确保片库始终紧跟播出节奏。"
  },
  {
    id: 5,
    q: "影片资源齐全吗？会下架吗？",
    a: "色影视片库目前收录超过15000部影视作品，涵盖电视剧、电影、综艺、动漫、纪录片五大品类。经典老片和热门新作均有覆盖。因版权政策调整，个别内容可能临时下架，我们会通过站内公告提前通知，并为用户推荐同类替代影片。"
  },
  {
    id: 6,
    q: "如何反馈问题或提交观影需求？",
    a: "您可以通过本站「联系我们」板块提交反馈，或在影片播放页使用「报错」功能。想看的影片如果片库中没有，欢迎在「求片专区」留言，我们的内容团队会优先采购热门需求影片。通常高需求影片会在3-7个工作日内上线。"
  }
];

export const mediaItems = [
  {
    id: 1,
    title: "《庆余年2》名场面混剪",
    desc: "范闲朝堂激辩，权谋大戏高潮迭起",
    duration: "05:32",
    views: "128万",
    img: "https://readdy.ai/api/search-image?query=Dramatic%20ancient%20Chinese%20courtroom%20scene%20with%20intense%20characters%20in%20traditional%20robes%2C%20cinematic%20lighting%20with%20strong%20contrast%2C%20warm%20golden%20tones%2C%20film%20still%20quality%2C%20horizontal%20composition&width=640&height=360&seq=media-1&orientation=landscape"
  },
  {
    id: 2,
    title: "《流浪地球3》幕后特辑",
    desc: "独家探班，揭秘中国科幻视效制作全过程",
    duration: "12:18",
    views: "96万",
    img: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20sci-fi%20film%20set%20with%20green%20screen%20and%20camera%20equipment%2C%20professional%20film%20production%20atmosphere%2C%20warm%20work%20lights%2C%20cinematic%20documentary%20style%2C%20horizontal%20composition&width=640&height=360&seq=media-2&orientation=landscape"
  },
  {
    id: 3,
    title: "《声生不息》经典舞台回顾",
    desc: "粤语金曲全新编曲，殿堂级现场一次听够",
    duration: "08:45",
    views: "203万",
    img: "https://readdy.ai/api/search-image?query=A%20grand%20concert%20stage%20with%20dramatic%20spotlight%20and%20musician%20silhouette%2C%20emotional%20performance%20moment%2C%20warm%20golden%20stage%20lighting%2C%20professional%20broadcast%20photography%2C%20horizontal%20composition&width=640&height=360&seq=media-3&orientation=landscape"
  },
  {
    id: 4,
    title: "《繁花》沪语版独家花絮",
    desc: "王家卫片场亲自指导，胡歌马伊琍对手戏精彩",
    duration: "06:20",
    views: "187万",
    img: "https://readdy.ai/api/search-image?query=Film%20director%20working%20with%20actors%20on%20a%20nostalgic%20period%20set%2C%20warm%20atmospheric%20lighting%2C%20vintage%20aesthetic%2C%20professional%20behind%20the%20scenes%20photography%2C%20horizontal%20composition&width=640&height=360&seq=media-4&orientation=landscape"
  }
];

export const featureItems = [
  {
    id: 1,
    icon: "ri-speed-up-line",
    title: "极速不缓冲",
    desc: "P2P-CDN混合加速，300+节点覆盖全国，高峰时段流畅度99.7%，彻底告别卡顿等待"
  },
  {
    id: 2,
    icon: "ri-4k-line",
    title: "高清画质",
    desc: "支持360P至4K多档画质自由切换，智能自适应码率，低带宽也能流畅观看"
  },
  {
    id: 3,
    icon: "ri-device-line",
    title: "多端同步",
    desc: "PC、手机、平板、电视全平台覆盖，播放进度和收藏列表自动跨设备同步"
  },
  {
    id: 4,
    icon: "ri-database-2-line",
    title: "海量片库",
    desc: "15000+影视作品收录，电视剧、电影、综艺、动漫、纪录片五大品类全覆盖"
  },
  {
    id: 5,
    icon: "ri-shield-check-line",
    title: "安全纯净",
    desc: "全站HTTPS加密传输，无恶意弹窗和捆绑软件，纯净观影体验有保障"
  }
];

export const topicItems = [
  { id: 1, tag: "#庆余年2大结局", heat: "2.8亿讨论", trend: "hot" },
  { id: 2, tag: "#繁花沪语版封神", heat: "1.6亿讨论", trend: "hot" },
  { id: 3, tag: "#流浪地球3视效", heat: "9800万讨论", trend: "new" },
  { id: 4, tag: "#长相思2虐哭了", heat: "1.2亿讨论", trend: "hot" },
  { id: 5, tag: "#哪吒2票房纪录", heat: "8600万讨论", trend: "stable" },
  { id: 6, tag: "#声生不息名场面", heat: "7200万讨论", trend: "new" },
  { id: 7, tag: "#暑期档追剧指南", heat: "6500万讨论", trend: "hot" },
  { id: 8, tag: "#不缓冲看片体验", heat: "5400万讨论", trend: "stable" },
  { id: 9, tag: "#国产科幻崛起", heat: "4800万讨论", trend: "new" }
];

export const updateItems = [
  { id: 1, date: "2026-07-31", title: "《庆余年》第二季大结局重磅上线", type: "更新" },
  { id: 2, date: "2026-07-30", title: "暑期档专题「盛夏追剧不缓冲」正式上线", type: "专题" },
  { id: 3, date: "2026-07-29", title: "平台新增4K超清专区，200+影片完成画质升级", type: "升级" },
  { id: 4, date: "2026-07-28", title: "《流浪地球3》导演剪辑版独家登陆平台", type: "上新" },
  { id: 5, date: "2026-07-27", title: "P2P加速节点扩增至320个，覆盖更多城市", type: "优化" },
  { id: 6, date: "2026-07-26", title: "《声生不息·大湾区季》收官之夜全集汇总", type: "更新" },
  { id: 7, date: "2026-07-25", title: "手机端播放器升级，新增手势调节亮度音量", type: "升级" },
  { id: 8, date: "2026-07-24", title: "《哪吒之魔童闹海》加长版含独家花絮上线", type: "上新" }
];